var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1504_2875)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1504_2875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1494 25.7695C27.812 26.7246 26.4708 27.5147 25.4012 27.7458C24.669 27.9012 23.7142 28.0242 20.497 26.691C16.8836 25.194 11.866 19.8614 11.866 16.3127C11.866 14.5061 12.9076 12.4025 14.729 12.4025C15.6054 12.4025 15.7986 12.4196 16.087 13.1114C16.4244 13.9265 17.2476 15.9346 17.3456 16.1404C17.7502 16.9849 16.934 17.4792 16.3418 18.2145C16.1528 18.4357 15.9386 18.675 16.178 19.0867C16.416 19.49 17.2392 20.8317 18.4488 21.9086C20.0112 23.3006 21.2782 23.745 21.7318 23.9341C22.0692 24.0741 22.4724 24.0415 22.7188 23.7782C23.031 23.4407 23.4188 22.8808 23.8136 22.329C24.0922 21.9341 24.4464 21.8848 24.8174 22.0248C25.068 22.1116 28.253 23.5908 28.3874 23.8274C28.4868 23.9997 28.4868 24.8144 28.1494 25.7695ZM20.0028 6H19.9958C12.2776 6 6 12.2795 6 20C6 23.0613 6.98701 25.9015 8.66561 28.2052L6.92121 33.4073L12.3014 31.6881C14.5148 33.1529 17.1566 34 20.0028 34C27.721 34 34 27.7205 34 20C34 12.2795 27.721 6 20.0028 6Z",
    fill: "#0D3653"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    stroke: "#949599",
    strokeDasharray: "6 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1504_2875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1504_2875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiWhatsapp);
export default __webpack_public_path__ + "static/media/mdi_whatsapp.fccef9b57ff6497ac5a2a1bf0b9c8d62.svg";
export { ForwardRef as ReactComponent };